<template>
  <div id="app" :data-route="currentRouteName">
    <HeaderView />
    <router-view />
    <FooterView />
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "header-view",
  components: {
    HeaderView,
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style>
#app {


  background: black;
  background-image: url('@/assets/fond.jpg') !important;
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;

  
}
</style>